import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function PartnerModal({
  createInput,
  createTextArea,
  createUserManagement,
  formData,
  getUserManagementList,
  history,
  showUserManagement,
  // createUploader,
  getRoleList,
  creating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        start_date: `${moment(_.get(formData, 'start_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        end_date: `${moment(_.get(formData, 'end_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        photo: formData.photo.cdnUrl,
      };

      createUserManagement(args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        history.push(`/important-notification/${_.get(data, 'id')}`);
        showUserManagement(data.id);
      });
    }
    if (!_.isObject(formData.photo)) {
      const args = {
        ...formData,
        start_date: `${moment(_.get(formData, 'start_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        end_date: `${moment(_.get(formData, 'end_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
      };
      createUserManagement(args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        history.push(`/important-notification/${_.get(data, 'id')}`);
        showUserManagement(data.id);
      });
    }
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {/* <div className="row d-flex justify-content-center">
          <div className="col-4">
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-4 form-group">
            {createUploader(
              { key: 'photo', label: 'Browse' },
              { required: true, crop: 'free' }
            )}
          </div>
        </div> */}

        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'title', label: 'Title:' },
              { required: true, placeholder: 'Citizen Type Title' }
            )}
          </div>
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'description', label: 'Description:' },
              { required: true, placeholder: 'Citizen Type Description' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

PartnerModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  createUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  // createUploader: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PartnerModal);
